import { render, staticRenderFns } from "./tagList.vue?vue&type=template&id=5c2651fc&scoped=true&"
import script from "./tagList.vue?vue&type=script&lang=js&"
export * from "./tagList.vue?vue&type=script&lang=js&"
import style0 from "./tagList.vue?vue&type=style&index=0&id=5c2651fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2651fc",
  null
  
)

export default component.exports